import React, { useState, useEffect } from 'react';
import moment from 'moment';
import i18next from 'i18next';

import { makeStyles } from '@material-ui/core/styles';

import { getDate } from 'lib/commonLib';
import { requestMcTargetStatistics } from 'lib/api/request';

import FilterWrap from 'components/atoms/FilterWrap';
import TableContainer from 'components/molecules/MbTable';
import StatisticsCommonFilter from 'components/organisms/StatisticsCommonFilter';

import McTargetStatisticsGraph from './McTargetStatisticsGraph';

const useStyles = makeStyles((theme) => ({
  notiTextBox: {
    position: 'relative',
    top: -15,
    color: 'red',
  },
}));

let initialization = false;
const McTargetStatistics = () => {
  // const { t } = useTranslation();
  const classes = useStyles();
  const sDate = moment().subtract(1, 'days');
  const eDate = moment().subtract(1, 'days');
  const initParam = {
    sDate: getDate(sDate),
    eDate: getDate(eDate),
  };
  // 공통 필터에서 초기값 받아왔는지 확인
  const [getInitParam, setGetInitParam] = useState(false);
  const [params, setParams] = useState(initParam);

  useEffect(() => {
    // 렌더링 후에 실행됨
    // params setting(필터링 혹은 초기 param setting) > 렌더링 > 초기화 값 초기화
    initialization = false;
  }, [params]);

  // header 및 body 컬럼 커스텀
  const customized = {};

  /**
   * 필터 초기화
   */
  const handleOnReset = () => {
    initialization = true;
    setParams(initParam);
  };

  const getParam = (newParams) => {
    setGetInitParam(true);
    setParams({
      ...params,
      ...newParams,
    });
  };

  return (
    <>
      <FilterWrap handleOnReset={handleOnReset}>
        <StatisticsCommonFilter
          initialization={initialization}
          pltfomTpCodeDetailFilter={['03', '04']}
          getParam={getParam}
          initData={initParam}
        />
      </FilterWrap>
      <div className={classes.notiTextBox}>
        <span>
          ※
          {i18next.t(
            '상품검색은 정확한 데이터가 아닙니다. 참고용으로만 사용하세요.'
          )}
        </span>
      </div>
      {getInitParam && (
        <>
          <McTargetStatisticsGraph params={{ ...params }} />
          <TableContainer
            dataReqPromise={requestMcTargetStatistics}
            params={{ ...params }}
            sort="desc"
            order="ADVRTS_AMT"
            dense={true}
            customized={customized}
            hasExcel
            hasTotal
          />
        </>
      )}
    </>
  );
};

export default McTargetStatistics;
